import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-spot",
  "use": "icon-spot-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-spot\"><defs><style></style></defs><path d=\"M320 480a2.5 2.5 0 1 0 320 0 2.5 2.5 0 1 0-320 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol